import React from 'react';
import { Card, Table, Row, Col, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Dollars from '../../common/typeFormatting/Dollars';
import IntegerFmt from '../../common/typeFormatting/IntegerFmt';

const VoucherList = ({ voucherList, voucherGroupId }) => {
  const history = useHistory();
  const { vouchers, totals } = voucherList;

  // Sort vouchers by employee name
  const sortedVouchers = [...vouchers].sort((a, b) => 
    a.employeeName.localeCompare(b.employeeName)
  );

  const handleRowClick = (voucherId) => {
    history.push(`/travel/vouchergroups/${voucherGroupId}/vouchers/${voucherId}/edit`);
  };

  const handleAddVoucher = () => {
    history.push(`/travel/vouchergroups/${voucherGroupId}/vouchers/add`);
  };

  const handleBulkIssue = () => {
    history.push(`/travel/vouchergroups/${voucherGroupId}/vouchers/bulk-issue`);
  };

  const getExpirationDisplay = (voucher) => {
    if (!voucher.expirationDate) return 'Does not expire';
    return new Date(voucher.expirationDate).toLocaleDateString();
  };

  return (
    <Card>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Card.Title>Allowances</Card.Title>
          <div>
            <Button variant="primary" onClick={handleAddVoucher} className="me-2">
              Issue Allowance
            </Button>
            <Button variant="secondary" onClick={handleBulkIssue}>
              Bulk Issue
            </Button>
          </div>
        </div>
        
        <Row className="mb-4">
          <Col md={4} className="text-center">
            <div className="mb-2">Total Issued</div>
            <h4><IntegerFmt>{totals.totalCount}</IntegerFmt></h4>
          </Col>
          <Col md={4} className="text-center">
            <div className="mb-2">Total Initial Balance</div>
            <h4><Dollars>{totals.totalInitialBalance}</Dollars></h4>
          </Col>
          <Col md={4} className="text-center">
            <div className="mb-2">Total Current Balance</div>
            <h4><Dollars>{totals.totalCurrentBalance}</Dollars></h4>
          </Col>
        </Row>

        <Table hover responsive className="mt-3">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Issue Date</th>
              <th className="text-right">Initial Amount</th>
              <th className="text-right">Current Balance</th>
              <th>Expiration Date</th>
            </tr>
          </thead>
          <tbody>
            { sortedVouchers.length > 0 ?
              sortedVouchers.map(voucher => (
              <tr 
                key={voucher.voucherId} 
                onClick={() => handleRowClick(voucher.voucherId)}
                style={{ cursor: 'pointer' }}
              >
                <td>{voucher.employeeName}</td>
                <td>{new Date(voucher.issueDate).toLocaleDateString()}</td>
                <td className="text-right"><Dollars>{voucher.initialAmount}</Dollars></td>
                <td className="text-right"><Dollars>{voucher.balance}</Dollars></td>
                <td>{getExpirationDisplay(voucher)}</td>
              </tr>
            )) : <tr><td>No vouchers issued yet.</td></tr>}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default VoucherList;